export default {"src":"/planos/_next/static/media/facebook-icon.278c40fc.svg","height":16,"width":9,"blurWidth":0,"blurHeight":0};